<template>
  <v-autocomplete
    v-model="preset"
    :items="presets"
    label="Preset"
    background-color="grey lighten-1"
    class="pt-1"
    clearable
    dense
    solo
    flat
    item-text="alias"
    item-value="alias"
    return-object
    hide-details
  />
</template>

<script>
export default {
  name: 'PresetsAutocomplete',
  props: {},
  data () {
    return {
      preset: null,
      presets: []
    }
  },
  watch: {
    preset (newVal) {
      if (newVal) {
        this.$emit('update', newVal)
      }
    },
    map_id (newVal) {
      if (this.preset && newVal !== this.preset.map_id) {
        this.preset = null
      }
    },
    build_id (newVal) {
      if (this.preset && newVal !== this.preset.build_id) {
        this.preset = null
      }

      const preset = this.presets.find(p => p.build_id === newVal && p.map_id === this.map_id)
      if (preset) {
        this.preset = preset
      }
    }
  },
  async mounted () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/builds/presets')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.presets = data

      const preset = this.presets.find(p => p.build_id === this.build_id && p.map_id === this.map_id)
      if (preset) {
        this.preset = preset
      }
    }
  },
  computed: {
    map_id () {
      return this.$store.state.telemetry.map_id
    },
    build_id () {
      return this.$store.state.telemetry.build_id
    },
  }
}
</script>